import accordion from './accordion'
import accordionPreview from './accordion-preview'
import tabs from './tabs'
import tracking from './tracking'
import carousel from './carousel'

accordion()
accordionPreview()
tabs()
tracking()
carousel()
